export default "__VITE_ASSET__DenVKM66__"